import { isEmpty } from "lodash";
import { FlexibleFields } from "features/assessment/constants";

const {
  TEXT_FIELD,
  RADIO_FIELD,
  NUMERIC_FIELD,
  CHECKBOX_FIELD,
  COMPOUND_RADIO,
  DATETIME_FIELD,
} = FlexibleFields;

const isEmptyText = (typeId, value) => {
  return typeId === TEXT_FIELD && isEmpty(value);
};

const isEmptyNumeric = (typeId, value) => {
  return typeId === NUMERIC_FIELD && isEmpty(value);
};

const isEmptyCheckbox = (typeId, value) => {
  return typeId === CHECKBOX_FIELD && isEmpty(value);
};

const isEmptyRadio = (typeId, value) => {
  return typeId === RADIO_FIELD && isEmpty(value);
};

const isEmptyCompound = (typeId, value) => {
  return typeId === COMPOUND_RADIO && isEmpty(value);
};

const isEmptyDatefield = (typeId, value) => {
  return typeId === DATETIME_FIELD && isEmpty(value);
};

function startsWithNumber(str) {
  return /^\d/.test(str);
}

function compare(a, b) {
  const _a = a.title;
  const _b = b.title;

  if (startsWithNumber(_a) && startsWithNumber(_b))
    return parseInt(a.title) - parseInt(b.title);

  if (_a < _b) return -1;
  if (_a > _b) return 1;
  return 0;
}

export {
  compare,
  isEmptyText,
  isEmptyNumeric,
  isEmptyCheckbox,
  isEmptyRadio,
  isEmptyCompound,
  isEmptyDatefield,
};
